import { FieldMetaProps } from 'formik';

export type FieldValidity = 'Untouched' | 'Valid' | 'Invalid';

export const getFieldValidity = (fieldMeta: FieldMetaProps<unknown>) => {
  return !fieldMeta.touched ? 'Untouched' : fieldMeta.error != null ? 'Invalid' : 'Valid';
};
